 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		2: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		2: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"component---src-pages-elections-vote-jsx","4":"component---src-pages-404-jsx","5":"component---src-pages-about-us-budget-jsx","6":"component---src-pages-about-us-constitution-jsx","7":"component---src-pages-about-us-ieee-code-of-conduct-jsx","8":"component---src-pages-about-us-mailing-list-sign-up-jsx","9":"component---src-pages-about-us-mc-naughton-centre-jsx","10":"component---src-pages-about-us-meeting-minutes-jsx","11":"component---src-pages-contact-us-mailing-list-sign-up-jsx","12":"component---src-pages-contact-us-office-hours-jsx","13":"component---src-pages-elections-confirmation-jsx","14":"component---src-pages-elections-election-platforms-jsx","15":"component---src-pages-elections-election-results-jsx","16":"component---src-pages-elections-elections-jsx","17":"component---src-pages-elections-elections-original-jsx","18":"component---src-pages-elections-vote-main-jsx","19":"component---src-pages-events-events-jsx","20":"component---src-pages-execs-execs-2018-2019-jsx","21":"component---src-pages-execs-execs-2019-2020-jsx","22":"component---src-pages-execs-execs-2020-2021-jsx","23":"component---src-pages-execs-execs-2021-2022-jsx","24":"component---src-pages-execs-execs-2022-2023-jsx","25":"component---src-pages-gallery-gallery-jsx","26":"component---src-pages-index-jsx","27":"component---src-pages-office-hours-office-hours-jsx","28":"component---src-pages-volunteer-volunteer-jsx","29":"component---src-pages-vr-campus-vr-campus-jsx","30":"component---src-pages-wie-wie-jsx","31":"component---src-templates-vr-image-template-js","32":"d25bd147"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"4ebf259fbfdb454ac04e","4":"308e27d8b1e5960d0a2e","5":"90451baba8b832a523c1","6":"1e4929d13561b9b89504","7":"6a96b8ef996a98a7145c","8":"fa8a3b78d8a965a00ad8","9":"5aaaae5f627f741c92e4","10":"b7c36cc1a5f7008dfb46","11":"7a17209af49e15815952","12":"e97e215c74565e3c6f7d","13":"b49dc92e662bf920d322","14":"910fcaa96cc82a11a0c6","15":"1f6f2cdb9013ddc8e24c","16":"4f018a511a63ad2e835a","17":"3e95168d15dd925852db","18":"39e46d2ced761483f135","19":"1ae0d5a5b58cf797c265","20":"b674cd774c85a8d886d3","21":"08906d5dcb1e600a1a2b","22":"7b26ae134e18dc7ae6d6","23":"05cb1b695bca7cff7532","24":"8ccc341ea989732c9fb5","25":"e0bd016743148a2c9362","26":"6d7c3181401ab510e614","27":"bccfbe420a28a60a1d07","28":"36381921ea8309215dd2","29":"17f41cf329bcc74efe70","30":"7468410604695586055a","31":"d9c85e059743b36c78ff","32":"5c26730533c81fb0da28","35":"2de3b6102613df8931cb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"component---src-pages-elections-vote-jsx","4":"component---src-pages-404-jsx","5":"component---src-pages-about-us-budget-jsx","6":"component---src-pages-about-us-constitution-jsx","7":"component---src-pages-about-us-ieee-code-of-conduct-jsx","8":"component---src-pages-about-us-mailing-list-sign-up-jsx","9":"component---src-pages-about-us-mc-naughton-centre-jsx","10":"component---src-pages-about-us-meeting-minutes-jsx","11":"component---src-pages-contact-us-mailing-list-sign-up-jsx","12":"component---src-pages-contact-us-office-hours-jsx","13":"component---src-pages-elections-confirmation-jsx","14":"component---src-pages-elections-election-platforms-jsx","15":"component---src-pages-elections-election-results-jsx","16":"component---src-pages-elections-elections-jsx","17":"component---src-pages-elections-elections-original-jsx","18":"component---src-pages-elections-vote-main-jsx","19":"component---src-pages-events-events-jsx","20":"component---src-pages-execs-execs-2018-2019-jsx","21":"component---src-pages-execs-execs-2019-2020-jsx","22":"component---src-pages-execs-execs-2020-2021-jsx","23":"component---src-pages-execs-execs-2021-2022-jsx","24":"component---src-pages-execs-execs-2022-2023-jsx","25":"component---src-pages-gallery-gallery-jsx","26":"component---src-pages-index-jsx","27":"component---src-pages-office-hours-office-hours-jsx","28":"component---src-pages-volunteer-volunteer-jsx","29":"component---src-pages-vr-campus-vr-campus-jsx","30":"component---src-pages-wie-wie-jsx","31":"component---src-templates-vr-image-template-js","32":"d25bd147"}[chunkId]||chunkId) + "." + {"0":"3e69913cb3ddf173b70d","1":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
